{
  "version": 1,
  "asset_id": "1af9e853-f7eb-424e-9703-47fe285c5e2b",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/1af9e853-f7eb-424e-9703-47fe285c5e2b/exterior-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/1af9e853-f7eb-424e-9703-47fe285c5e2b/exterior-card.webp",
  "original_filename": "exterior-card.webp",
  "size": 18956,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:22Z"
}
